jQuery(function ($) {
    $('.sponsor-index-block__wrapper').infiniteScroll({
        path: '.pagination .next',
        append: '.single-block',
        status: '.scroller-status',
        hideNav: '.pagination',
        scrollThreshold: false,
        button: '.view-more-button',
        checkLastPage: true,
    });
});

jQuery(function ($) {
    $('.news-stories').infiniteScroll({
        path: '.pagination-success .next',
        append: '.single-story',
        status: '.scroller-status',
        hideNav: '.pagination-success',
        scrollThreshold: false,
        button: '.view-more-button',
        checkLastPage: true,
    });
});

jQuery(function ($) {
    $('.memorialise-index-block__wrapper').infiniteScroll({
        path: '.pagination-memorial .next',
        append: '.single-memorial',
        status: '.scroller-status',
        hideNav: '.pagination-memorial',
        scrollThreshold: false,
        button: '.view-more-button',
        checkLastPage: true,
    });

    $('.memorialise-index-block__wrapper').on( 'append.infiniteScroll', function( event, response, path, items ) {
        setTimeout(function () {
            $('.memorialise-index-block__wrapper .view-more-button').insertAfter('.memorialise-index-block__wrapper .single-memorial:last');
        }, 20);
    });

    $('.news-stories').on( 'append.infiniteScroll', function( event, response, path, items ) {
        setTimeout(function () {
            $('.news-stories .view-more-button').insertAfter('.news-stories .single-block:last');
            $('.news-stories').align({
                selector: '.single-story__wrapper > *'
            });
        }, 20);
    });

    $('.sponsor-index-block__wrapper').on( 'append.infiniteScroll', function( event, response, path, items ) {
        setTimeout(function () {
            $('.sponsor-index-block__wrapper .view-more-button').insertAfter('.sponsor-index-block__wrapper .single-block:last');
        }, 20);
    });
});

jQuery(function ($) {
    $(window).on('load', function() {
        setTimeout(initiateParallax, 500);
    });

    function initiateParallax() {
        $('.donate-parallax').parallax({imageSrc: 'https://www.animalaidunlimited.org/wp-content/themes/cgit-animal-aid-unlimited/images/donate-background-desktop.jpg'});
    }

    jQuery(window).trigger('resize').trigger('scroll');
});